export enum OrderDeliveryType {
  Pickup = 'pickup',
  Shipment = 'shipment',
  Email = 'email',
  PickupExternal = 'pickupExternal'
}
